require('../sidebarMenu/sidebarMenuDirective');

"use strict";

angular.module('app.mainFrame.sidebarContentController', [
    'app.mainFrame.sidebarMenu.sidebarMenuDirective'
])
    .controller('app.mainFrame.sidebarContentController', [
        '$scope',
        function () {
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/sidebar/sidebarContentController.js